<template>
  <span class="diag-partially-supported el-icon-question"></span>
</template>
<script>
export default {
  name: 'diag-partially-supported',
}
</script>
<style lang="less">
.diag-partially-supported {
  color: #e6a23c;
}
</style>